export enum Section {
    ViewToolRequests = 1,
    ApproveToolRequests = 2,
    ProcessToolRequests = 3,
    ViewToolReturns = 4,
    ApproveToolReturns = 5,
    ProcessToolReturns = 6
}
